import { HttpClient, HttpResponse } from '@angular/common/http';
import proxyConfigs from '@config/proxy-config.json';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpHandler, HttpHandlerGetArg, HttpHandlerPostArg, HttpHandlerArgModel, HttpHandlerMethodArg } from './http.service';
import { Observable, Subscriber } from 'rxjs';

const jwtHelper = new JwtHelperService();

export class BaseMoghimApiResponse<T>
{
    total: number;
    issuccess: boolean;
    errors: Array<MoghimApiErrorResponseItem>;
}
export class MoghimSingleApiResponse<T> extends BaseMoghimApiResponse<T>{
    data: T;
}
export class MoghimApiResponse<T> extends BaseMoghimApiResponse<T>{
    data: Array<T>
}
export class MoghimApiErrorResponseItem {
    errorcode: string;
    errormessage: string;
}
export class AutomateLoginInfo {
    public username: string;
    public password: string;
    public baseUrl: string;
    public endpoint: string;
}
export class MoghimApiProxyResult<T>
{
    public httpStatusCode?: number;
    public isSuccess?= () => this.httpStatusCode >= 200 && this.httpStatusCode <= 209 && this.errors == null && !(this.isUnauthorized()) && !this.hasInvalidToken;
    public hasError?= () => !this.isSuccess;
    public isUnauthorized?= () => (this.httpStatusCode == 401 || this.hasInvalidToken);
    public errors?: Array<MoghimApiErrorResponseItem>;
    public errorItem?= () => this.errors && this.errors.length ? this.errors[0] : new MoghimApiErrorResponseItem();
    public model?: T;
    public hasInvalidToken?: boolean;

    constructor() {
        this.httpStatusCode = 0;
        this.errors = null;
        this.hasInvalidToken = false;
    }
}

export class pingModel {
    areaName: string;
    ping: string;
    who: string;
}

export abstract class BaseMoghimProxyService {

    protected _httpHandler: HttpHandler;
    protected _config: any;
    protected _proxySection: any;
    protected _defaultSettings: HttpHandlerArgModel;
    protected _defaultApiSettings: HttpHandlerMethodArg;
    protected _bootstrapped : boolean = false;
    public token: string;

    //get ProxyConfig() { return this._proxySection; }
    private invalidTokenResult: any;

    constructor(
        protected http: HttpClient,
        protected proxyName: string,
        protected baseSettings?: HttpHandlerArgModel,
        protected proxySectionName: string = 'MoghimProxies',
    ) {
        this.token = '';
        // this._config = proxyConfigs;
        this.invalidTokenResult = {
            hasInvalidToken: true,
            model: null,
            errors: new Array<MoghimApiErrorResponseItem>()
        };
        this.invalidTokenResult.errors.push({ errorcode: "Invalid_Token", errormessage: 'Invalid Token' });

        this.bootstrap().then(() => {});
    }
    
    private async bootstrap() : Promise<any>
    {
        return this.GetProxyConfig(this.proxySectionName,this.proxyName)
            .then((response) => {
				this._proxySection = response;

                this._defaultSettings = {
                    baseUrl: (this._proxySection && this._proxySection.baseUrl && this._proxySection.baseUrl.length ? this._proxySection.baseUrl : ''),
                    authorization: {
                        type: 'header',
                        headerName: 'authorization',
                        authType: 'bearer'
                    },
                    header: [
                        { key: 'Cache-Control', value: 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0' },
                        { key: 'Pragma', value: 'no-cache' },
                        { key: 'Expires', value: '0' }
                        //{ key : 'Accept-Encoding' , value : 'gzip,deflate' }
                    ],
                    handleDefaultAuthExceptions: true,
                    onInvalidToken: () => { console.log('BaseMoghimProxyService._defaultApiSettings.onInvalidToken'); },
                    onUnauthorized: () => { console.log('BaseMoghimProxyService._defaultApiSettings.onUnauthorized'); }
                };
                
                this._defaultApiSettings = {
                    needToken: true,
                    token: ''
                };

                this.baseSettings = Object.assign(this._defaultSettings, this.baseSettings);
                this._httpHandler = new HttpHandler(this.http, this.baseSettings);
                this._bootstrapped = true;
            });
    }

    protected async getDefaultSettings() : Promise<HttpHandlerArgModel>
    {
        if(this._bootstrapped) return this._defaultSettings;
        await this.bootstrap();
        return this._defaultSettings;
    }

    protected async getDefaultApiSettings() : Promise<HttpHandlerMethodArg>
    {
        if(this._bootstrapped) return this._defaultApiSettings;
        await this.bootstrap();
        return this._defaultApiSettings;
    }
    // public async getProxySection() {
    //     let result = await this.GetProxyConfig(this.proxySectionName,this.proxyName);
    // }

    public async SendRequestAsync_old<T>(observer: any): Promise<MoghimApiProxyResult<T>> {
        try {
            let apiResult = await observer.toPromise();
            let result = this.ProcessApiResult<T>(apiResult);
            return Promise.resolve(result);
        }
        catch (e) {
            var error = new MoghimApiProxyResult<T>();
            error.errors = new Array<MoghimApiErrorResponseItem>();
            var errorItem = new MoghimApiErrorResponseItem();
            errorItem.errorcode = '$Unhanled$';
            errorItem.errormessage = 'Unhanled error in BaseProxyService';
            error.errors.push(errorItem);
            return new Promise((resolve, reject) => {
                reject(error);
            });
        }
    }

    // ارسال درخواست های پرامیس
    public async SendRequestAsync<T>(arg: any, observer: any): Promise<MoghimApiProxyResult<T>> {
        var promiseToRun = async (arg: any) => {
            const requestArg = await this.ExtendMethodArg(arg);
            if (requestArg && requestArg.invalidToken) {
                if (requestArg.handleDefaultAuthExceptions && requestArg.onInvalidToken && typeof (requestArg.onInvalidToken) === 'function') {
                    requestArg.onInvalidToken();
                }
                return Promise.resolve(Object.assign(new MoghimApiProxyResult<T>(), this.invalidTokenResult));
            }
            else {
                let apiResult = await observer.toPromise();
                let observerResult = this.ProcessApiResult<T>(apiResult);
                if (observerResult && observerResult.isUnauthorized()) {
                    if (requestArg.handleDefaultAuthExceptions && requestArg.onUnauthorized && typeof (requestArg.onUnauthorized) === 'function') {
                        requestArg.onUnauthorized(observerResult);
                    }
                }
                return Promise.resolve(observerResult);
            }
        }
        try {
            let result = await promiseToRun(arg);
            return Promise.resolve(result);
        }
        catch (e) {
            var error = new MoghimApiProxyResult<T>();
            error.errors = new Array<MoghimApiErrorResponseItem>();
            var errorItem = new MoghimApiErrorResponseItem();
            errorItem.errorcode = '$Unhanled$';
            errorItem.errormessage = 'Unhanled error in BaseProxyService';
            error.errors.push(errorItem);
            return new Promise((resolve, reject) => {
                reject(error);
            });
        }
    }

    // ارسال درخواتس های آبزروبل
    public SendRequestObservable<T>(arg: any, observerMethod: any): Observable<MoghimApiProxyResult<T>> {
        let result = new Observable((observer) => {
            this.ExtendMethodArg(arg)
                .then((requestArg) => {
                    if (requestArg && requestArg.invalidToken) {
                        if (requestArg.handleDefaultAuthExceptions && requestArg.onInvalidToken && typeof (requestArg.onInvalidToken) === 'function') {
                            requestArg.onInvalidToken();
                        }
                        observer.next(Object.assign(new MoghimApiProxyResult<T>(), this.invalidTokenResult));
                    }
                    else {
                        observerMethod(requestArg).subscribe(
                            (response) => {
                                var result = this.ProcessApiResult<T>(response);
                                if (result && result.isUnauthorized()) {
                                    if (requestArg.handleDefaultAuthExceptions && requestArg.onUnauthorized && typeof (requestArg.onUnauthorized) === 'function') {
                                        requestArg.onUnauthorized(result);
                                    }
                                }
                                observer.next(result);
                                observer.complete();
                            },
                            (reject) => {
                                observer.error(reject);
                                observer.complete();
                            }
                        );
                    }
                })
                .catch((reject) => {
                    observer.error(reject);
                    observer.complete();
                });
        });
        return result;
    }

    /********************************************************************************************************************************** */
    // "ارسال درخواست با متد "گِت" و دریافت "تکی اطلاعات" به صورت "پرامیس
    public async GetForSingleAsync<T>(arg: HttpHandlerGetArg): Promise<MoghimApiProxyResult<T>> {
        var observer = this._httpHandler.GetResponse<MoghimSingleApiResponse<T>>(arg);
        return await this.SendRequestAsync<T>(arg, observer);
    }

    // "ارسال درخواست با متد "گِت" و دریافت "تکی اطلاعات" به صورت "آبزروبل
    public GetForSingle<T>(arg: HttpHandlerGetArg): Observable<MoghimApiProxyResult<T>> {
        var observer = (p: HttpHandlerGetArg) => this._httpHandler.GetResponse<MoghimSingleApiResponse<T>>(p);
        return this.SendRequestObservable(arg, observer);
    }

    // "ارسال درخواست با متد "گِت" و دریافت "گروهی اطلاعات" به صورت "پرامیس
    public async GetAsync<T>(arg: HttpHandlerGetArg): Promise<MoghimApiProxyResult<T>> {
        var observer = this._httpHandler.GetResponse<MoghimApiResponse<T>>(arg);
        return await this.SendRequestAsync<T>(arg, observer);
    }

    // "ارسال درخواست با متد "گِت" و دریافت "گروهی اطلاعات" به صورت "آبزروبل
    public Get<T>(arg: HttpHandlerGetArg): Observable<MoghimApiProxyResult<T>> {
        var observer = (p: HttpHandlerGetArg) => this._httpHandler.GetResponse<MoghimApiResponse<T>>(p);
        return this.SendRequestObservable(arg, observer);
    }

    // "ارسال درخواست به صورت "جیسون" با متد "پُست" و دریافت "تکی اطلاعات" به صورت "پرامیس
    public async PostForSingleAsync<T>(arg: HttpHandlerPostArg): Promise<MoghimApiProxyResult<T>> {
        var observer = this._httpHandler.PostResponse<MoghimSingleApiResponse<T>>(arg);
        return await this.SendRequestAsync<T>(arg, observer);
    }

    // "ارسال درخواست به صورت "جیسون" با متد "پُست" و دریافت "تکی اطلاعات" به صورت "آبزروبل
    public PostForSingle<T>(arg: HttpHandlerPostArg): Observable<MoghimApiProxyResult<T>> {
        var observer = (p: HttpHandlerPostArg) => this._httpHandler.PostResponse<MoghimSingleApiResponse<T>>(p);
        return this.SendRequestObservable(arg, observer);
    }

    // "ارسال درخواست به صورت "یو-آر-ال-اینکودد" با متد "پُست" و دریافت "تکی اطلاعات" به صورت "پرامیس
    public async PostUrlEncodedForSingleAsync<T>(arg: HttpHandlerPostArg): Promise<MoghimApiProxyResult<T>> {
        var observer = this._httpHandler.PostUrlEncodedResponse<MoghimSingleApiResponse<T>>(arg);
        return await this.SendRequestAsync<T>(arg, observer);
    }

    // "ارسال درخواست به صورت "یو-آر-ال-اینکودد" با متد "پُست" و دریافت "تکی اطلاعات" به صورت "آبزروبل
    public PostUrlEncodedForSingle<T>(arg: HttpHandlerPostArg): Observable<MoghimApiProxyResult<T>> {
        var observer = (p: HttpHandlerPostArg) => this._httpHandler.PostUrlEncodedResponse<MoghimSingleApiResponse<T>>(p);
        return this.SendRequestObservable(arg, observer);
    }

    // "ارسال درخواست به صورت "فرم-دیتا" با متد "پُست" و دریافت "تکی اطلاعات" به صورت "پرامیس
    public async PostFormDataForSingleAsync<T>(arg: HttpHandlerPostArg): Promise<MoghimApiProxyResult<T>> {
        var observer = this._httpHandler.PostFormDataResponse<MoghimSingleApiResponse<T>>(arg);
        return await this.SendRequestAsync<T>(arg, observer);
    }

    // "ارسال درخواست به صورت "فرم-دیتا" با متد "پُست" و دریافت "تکی اطلاعات" به صورت "آبزروبل
    public PostFormDataForSingle<T>(arg: HttpHandlerPostArg): Observable<MoghimApiProxyResult<T>> {
        var observer = (p: HttpHandlerPostArg) => this._httpHandler.PostFormDataResponse<MoghimSingleApiResponse<T>>(p);
        return this.SendRequestObservable(arg, observer);
    }

    // "ارسال درخواست به صورت "جیسون" با متد "پُست" و دریافت "گروهی اطلاعات" به صورت "پرامیس
    public async PostAsync<T>(arg: HttpHandlerPostArg): Promise<MoghimApiProxyResult<T>> {
        var observer = this._httpHandler.PostResponse<MoghimApiResponse<T>>(arg);
        return await this.SendRequestAsync<T>(arg, observer);
    }

    // "ارسال درخواست به صورت "جیسون" با متد "پُست" و دریافت "گروهی اطلاعات" به صورت "آبزروبل
    public Post<T>(arg: HttpHandlerPostArg): Observable<MoghimApiProxyResult<T>> {
        var observer = (p: HttpHandlerPostArg) => { return this._httpHandler.PostResponse<MoghimApiResponse<T>>(p); };
        return this.SendRequestObservable(arg, observer);
    }

    // "ارسال درخواست به صورت "یو-آر-ال-اینکودد" با متد "پُست" و دریافت "گروهی اطلاعات" به صورت "پرامیس
    public async PostUrlEncodedAsync<T>(arg: HttpHandlerPostArg): Promise<MoghimApiProxyResult<T>> {
        var observer = this._httpHandler.PostUrlEncodedResponse<MoghimApiResponse<T>>(arg);
        return await this.SendRequestAsync<T>(arg, observer);
    }

    // "ارسال درخواست به صورت "یو-آر-ال-اینکودد" با متد "پُست" و دریافت "گروهی اطلاعات" به صورت "آبزروبل
    public PostUrlEncoded<T>(arg: HttpHandlerPostArg): Observable<MoghimApiProxyResult<T>> {
        var observer = (p: HttpHandlerPostArg) => { return this._httpHandler.PostUrlEncodedResponse<MoghimApiResponse<T>>(p); };
        return this.SendRequestObservable(arg, observer);
    }

    // "ارسال درخواست به صورت "فرم-دیتا" با متد "پُست" و دریافت "گروهی اطلاعات" به صورت "پرامیس
    public async PostFormDataAsync<T>(arg: HttpHandlerPostArg): Promise<MoghimApiProxyResult<T>> {
        var observer = this._httpHandler.PostFormDataResponse<MoghimApiResponse<T>>(arg);
        return await this.SendRequestAsync<T>(arg, observer);
    }

    // "ارسال درخواست به صورت "فرم-دیتا" با متد "پُست" و دریافت "گروهی اطلاعات" به صورت "آبزروبل
    public PostFormData<T>(arg: HttpHandlerPostArg): Observable<MoghimApiProxyResult<T>> {
        var observer = (p: HttpHandlerPostArg) => { return this._httpHandler.PostFormDataResponse<MoghimApiResponse<T>>(p); };
        return this.SendRequestObservable(arg, observer);
    }
    /************************************************************************************************************************* */
    public async Ping(): Promise<MoghimApiProxyResult<pingModel>> {
        return this.GetForSingleAsync<pingModel>({
            endpoint: 'api/ping',
            needToken: true
        });
    }

    public async GetToken(input : TAuth.LoginInputModel) : Promise<string>
    {
        var loginInfo = await this.GetLoginInputModel(input);
        
        let loginResult = await this.PostForSingleAsync<TAuth.Login>({
            model: { username: loginInfo.username, password: loginInfo.password },
            url: loginInfo.baseUrl,
            endpoint: loginInfo.endpoint,
            needToken: false
        });
        if (loginResult.isSuccess()) {
            if (loginResult.model && loginResult.model.token && loginResult.model.token.length) {
                return loginResult.model.token;
            }
        }
        return '';
    }

    private async GetAutomaticToken(input: TAuth.LoginInputModel): Promise<string> {
        var token = await this.GetToken(input);
        if (token && token.length) {
            sessionStorage.setItem('_a_token', token);
            return token;
        }
        return '';
    }


    protected ProcessApiResult<T>(response: HttpResponse<BaseMoghimApiResponse<T>>): MoghimApiProxyResult<T> {
        var result = new MoghimApiProxyResult<T>();
        result.httpStatusCode = 0;

        if (response == null) return result;
        if (response === undefined) return result;


        result.httpStatusCode = response.status;

        if (response.body) {
            result.errors = response.body.errors;
            result.model = response.body["data"];
        }

        return result;
    }

    // public GetProxyConfigWithCache(proxySectionName : string,proxyName : string) : any
    // {
    //     let section = proxyConfigs[proxySectionName];
    //     // let section = this._config[proxySectionName];
    //     if(!section) return null;

    //     var result = section.filter(item => this.replaceAll(this.replaceAll(item.id,'_',''),'-','').toLowerCase() === this.replaceAll(this.replaceAll(proxyName,'_',''),'-','').toLowerCase());
    //     if(!result) return null;
    //     return result[0];
    // }
    
    public async GetProxyConfig(proxySectionName : string,proxyName : string) : Promise<any>
    {
        let promiseToRun = this.http.get('../../../assets/config/proxy-config.json').toPromise();
        let conf = await promiseToRun;
        
        let section = conf[proxySectionName];
        if(!section) return null;
        var result = section.filter(item => this.replaceAll(this.replaceAll(item.id,'_',''),'-','').toLowerCase() === this.replaceAll(this.replaceAll(proxyName,'_',''),'-','').toLowerCase());
        if(!result) return null;
        return result[0];
    }

    // public GetEndpointWithCache(endpointId : string,proxySection : any = null) : string
    // {
    //     if(!this._proxySection) return '';
    //     let endPoints = (proxySection && proxySection.endPoints ? proxySection.endPoints : this._proxySection.endPoints);
    //     let result = endPoints.filter(item => this.replaceAll(this.replaceAll(item.id,'_',''),'-','').toLowerCase() === this.replaceAll(this.replaceAll(endpointId,'_',''),'-','').toLowerCase());
    //     if(result) return (result && result[0] && result[0].endpoint ?  result[0].endpoint.toLowerCase() : '');
    //     return '';
    // }

    public async GetEndpoint(endpointId : string,proxySection : any = null) : Promise<string>
    {
        let _sec = await this.GetProxyConfig(this.proxySectionName,this.proxyName);
        if(!_sec) return '';
        let endPoints = (proxySection && proxySection.endPoints ? proxySection.endPoints : _sec.endPoints);
        let result = endPoints.filter(item => this.replaceAll(this.replaceAll(item.id,'_',''),'-','').toLowerCase() === this.replaceAll(this.replaceAll(endpointId,'_',''),'-','').toLowerCase());
        
        if(result) return (result && result[0] && result[0].endpoint ?  result[0].endpoint.toLowerCase() : '');
        return '';
    }

    protected async ExtendMethodArg(arg: any): Promise<any> {
        
        var defSettings = await this.getDefaultSettings();
        var defApiSettings = await this.getDefaultApiSettings();

        var result = Object.assign({ invalidToken: false }, defSettings, arg);

        var methodArg = Object.assign({}, defApiSettings, arg);
        result.url = (result.url && result.url.length) ? result.url : (defSettings.baseUrl && defSettings.baseUrl.length) ? defSettings.baseUrl : '';

        if (
            (!arg.endpoint || !arg.endpoint.length) // اگر دستی آدرس سرویس را وارد نکرده بدیم
            &&
            (arg.endPointId && arg.endPointId.length) // و به جاش آیدی آدرس سرویس در فایل کانفیگ را داده ب.دیم
        )
        {
            result.endpoint = await this.GetEndpoint(arg.endPointId);
        }
        // اگر برای اجرای سرویس باید توکن ارسال کنیم
        if (methodArg && methodArg.needToken && methodArg.needToken === true) {
            // اگر توکن را ست نکرده بودیم
            if (!methodArg.token || !methodArg.token.length) {
                var currentToken = '';
                var validateToken = false;

                // اگر توکن را بوسیله پراپرتی توکن پراکسی ست کرده بودیم
                if (this.token && this.token.length) {
                    currentToken = this.token;
                    validateToken = true;
                }
                else {
                    // اگر در سشن استورج مقدار کد مشتری داشتیم
                    currentToken = sessionStorage.getItem('_a_token');
                    validateToken = true;
                }

                if (currentToken && currentToken.length) {
                    if (validateToken) {
                        var expirationDate = new Date(jwtHelper.getTokenExpirationDate(currentToken).toString()).getTime();
                        var isExpired = jwtHelper.isTokenExpired(currentToken);
                        var now = new Date().getTime();
                        // نوکن اکسپایر شده بود و یا کمتر از یک دقیقه تا اکسپایرش مونده بود
                        if ((expirationDate - now <= 60000) || isExpired) {
                            //TODO : call renew token service
                            result.invalidToken = true;
                        }
                        else {
                            result.token = currentToken;
                        }
                    }
                    else {
                        result.token = currentToken;
                    }
                }
                else {
                    // توکن نداریم و باید بوسیله نام کاربری و کلمه عبور، توکن بگیریم
                    var automateLoginInputModel = null;
                    if
                        (
                        arg.security && arg.security.username && arg.security.username.length
                        && arg.security.password && arg.security.password.length
                    ) {
                        automateLoginInputModel = { username: arg.security.username, password: arg.security.password };
                    }
                    var token = await this.GetAutomaticToken(automateLoginInputModel);
                    if (token && token.length) {
                        result.token = token;
                    }
                }
            }
        }
        if (result.token === '') { result.invalidToken = true; }
        return result;
    }

    private async GetLoginInputModel(input : TAuth.LoginInputModel = null) : Promise<AutomateLoginInfo>
    {
        let defaultAuth = await this.GetProxyConfig(this.proxySectionName,'MoghimAuthentication');
        let proxyAuth = await this.GetProxyConfig(this.proxySectionName,this.proxyName);

        let defaultAuthInputModel = Object.assign({}, defaultAuth.security, proxyAuth.security);
        var result = Object.assign({}, defaultAuthInputModel, input);
        let loginBaseUrl = defaultAuth.baseUrl;
        let loginEndPoint = await this.GetEndpoint('login',defaultAuth);
        return {
            baseUrl: loginBaseUrl,
            endpoint: loginEndPoint,
            username: result.username,
            password: result.password
        };
    }
    private replaceAll(str: string, search: string, replacement: string): string {
        return str.replace(new RegExp(search, 'g'), replacement);
    }
}
